import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const PopularCarTypes = () => {
  return (
    <Swiper spaceBetween={20} slidesPerView={3}>
      <SwiperSlide>
        <img src="/assets/img/cars/mp-vehicle-01.svg" alt="Crossover" />
        <h6>Crossover</h6>
        <p>35 Cars</p>
      </SwiperSlide>
      <SwiperSlide>
        <img src="/assets/img/cars/mp-vehicle-02.svg" alt="Sports Coupe" />
        <h6>Sports Coupe</h6>
        <p>45 Cars</p>
      </SwiperSlide>
      {/* Add more slides here */}
    </Swiper>
  );
};